module.exports = __webpack_public_path__ + "static/salon-pasajeros---acabado-lateral-3715d1432f5d8be789e13c80c9feb540.jpg";